import * as React from "react"
import { FooterBottom, BottomFooterRoutes, TopFooter, TopFooterRoutes } from "../../shared";
import { User, RouteOutput} from "../../../types/types";
import { getClient } from "../../../api/graphql";
import { ApolloProvider } from "react-apollo";
import { FooterQuery, query, variables } from "../../../api/queries/footer";

import { ToDictionary } from "../../../api/routes";
import { PageLoader } from "../../shared/loaders/PageLoader";

type Props = {
  current_user: User
}


export default class extends React.Component<Props, {}> {
  constructor(props:Props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <ApolloProvider client={getClient()}>
        <FooterQuery
          query={query()}
          variables={variables(this.props.current_user)}
        >
          {({ loading, error, data}) => {
            if(loading) return <PageLoader />
            if(error) return <div>Something went wrong</div>
            return (
              <>
                <TopFooter
                  routes={ToDictionary<TopFooterRoutes>(data.topFooterRoutes)}
                  areas={data.highlighted_areas}
                />
                <FooterBottom
                  routes={ToDictionary<BottomFooterRoutes>(data.bottomFooterRoutes)}
                  current_user={this.props.current_user}
                  recaptcha_key={data.siteSettings.recaptchakey}
                />
              </>
            )
          }}
        </FooterQuery>
      </ApolloProvider>
    )
  }
}
